import React from 'react';
import { Container } from 'reactstrap';
import FormComponent from '../../views/Contact/FormComponent';
// import { useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { APIKey, GeolocationApiUrl, getVisitorLocation } from '../../common/GeneralUtils';
// import { HashLink as Link } from 'react-router-hash-link';

const ContactUsComponent = ({ setToasts, GeoIpData }) => {
    // const location = useLocation();
    // const [geoData, setGeoData] = useState(null);

    // const getIPGeoLocation = async (path) => {
    //     try {
    //         const res = await axios.get(`${GeolocationApiUrl}/?api-key=${APIKey}`);

    //         if (res?.status === 200) {
    //             const finalData = {
    //                 ...res.data,
    //                 pathVisited: path,
    //             };
    //             getVisitorLocation(finalData)
    //             setGeoData(finalData); // ✅ store in state
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };
    // useEffect(() => {
    //     getIPGeoLocation(location.pathname)
    // }, [location.pathname])
    return (
        <section className='Contact-Us-form'>
            <div className='custom-pending-top'>
                <div className='my-background'>
                    <div className='product'>
                        <Container className='custom-padding-py-100' >
                            <div className='text-center pb-4'>
                                <h4>Lets connect</h4>
                                <p className='m-0'>
                                    Let's work together to bring your ideas and vision to software reality.
                                </p>
                            </div>
                            <div className='connect-form-page'>
                                <FormComponent setToasts={setToasts} geoData={GeoIpData} />
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactUsComponent;
